export const isOptionInstrument = (instrument) =>
  String(instrument ?? '').toLowerCase().includes('option');
